import {axios} from '@/api/axios';
import {formatString} from '@/utils';
import {USER_URLS} from '@/api/urls';
import {UserClass} from '@/types/userClass';

export const UserApi = {
  getList: () => axios.get<UserClass[]>(USER_URLS.GET_LIST),
  getListByCategory: (id: string) => axios.get<UserClass[]>(formatString(USER_URLS.GET_LIST_BY_CATEGORY, id)),
  getOne: (id: string) => axios.get<UserClass>(formatString(USER_URLS.GET_EVENT, id)),

  save: (data: UserClass) => axios.post<UserClass>(USER_URLS.SAVE, data),
  edit: (id: string, data: UserClass) => axios.put<UserClass>(formatString(USER_URLS.EDIT, id), data),
  delete: (id: string) => axios.delete<UserClass>(formatString(USER_URLS.EDIT, id))
};
